import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import 'react-app-polyfill/ie11'
import 'core-js/stable'
import './polyfills'

ReactDOM.render(<App />, document.getElementById('root'))
